import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { Box } from '@mui/material';
import { CSS } from '@dnd-kit/utilities';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import CusChip from '../CusChip';

export default function SortableChip({ chip, onDelete, isActive }) {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({
    id: chip.value
  });

  return (
    <Box
      ref={setNodeRef}
      style={{
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isActive ? 0.5 : 1
      }}
      sx={{ display: 'inline-flex', alignItems: 'center' }}>
      <Box
        {...attributes}
        {...listeners}
        sx={{
          cursor: 'grab',
          mr: 0.5,
          color: 'grey.600',
          display: 'flex',
          alignItems: 'center',
          '&:active': { cursor: 'grabbing' }
        }}>
        <DragIndicatorIcon fontSize="small" />
        <CusChip option={chip} handleDelete={onDelete} />
      </Box>
    </Box>
  );
}
